import ShrinkWrapWrapper from './component/ShrinkWrapWrapper'
import ShrinkWrapItem from './component/ShrinkWrapItem'

const ShrinkWrap = ShrinkWrapWrapper
ShrinkWrap.displayName = 'ShrinkWrap'

ShrinkWrap.Item = ShrinkWrapItem
ShrinkWrap.Item.displayName = 'ShrinkWrap.Item'

export default ShrinkWrap
